import React, { useState, useEffect } from "react";
import TagManager from 'react-gtm-module';

import OpcoesRecebimento_controller from "../../../../../../../../../../../../../controllers/opcoesRecebimento";
import Log from "../../../../../../../../../../../../../controllers/log";
import ModalRadioButton from "../../../../../../../../../../../../util/modalDinamica/childrens/modalRadioButton/.mixins/multiSelectModal";

import Cookies from "universal-cookie";
import moment from "moment";
import { Typography } from "@material-ui/core";

export default function TableModal({
    isModalOpen,
    handleDialogModal,
    setCheckboxesId,
    checkboxesId,
    pedidoProtocoloNFSelecionados,
    reload,
    handleDialogModalAvisoSplitNota,
    handleDialogEscolhaNovaOpcaoPag,
}) {
    useEffect(() => {
        loadDescontos();
    }, [pedidoProtocoloNFSelecionados]);

    const [itensModal, setItensModal] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    let qtdItens = 0;
    let subtitle;
    if (pedidoProtocoloNFSelecionados.itens) {
        qtdItens = pedidoProtocoloNFSelecionados.itens.length;
        subtitle =
            qtdItens > 1
                ? `para o grupo de ${qtdItens} produtos.`
                : `para o produto ${pedidoProtocoloNFSelecionados.itens[0].NM_PROD}.`;
    }
    const headerModal = {
        title: "ESCOLHA A NOVA OPÇÃO DE PAGAMENTO",
        subtitle: subtitle,
    };

    function verifyUpdate() {
        const qtdItens = pedidoProtocoloNFSelecionados.itens.length;
        if (checkboxesId.length !== 0) {
            getIdOnClick();
            handleDialogModal();
            reload();
            if (qtdItens > 1) {
                handleDialogEscolhaNovaOpcaoPag();
            } else {
                handleDialogModalAvisoSplitNota();
            }
        }
    }

    function setIdOnChange(idRadioChecked) {
        setCheckboxesId(parseInt(idRadioChecked));
    }

    function getIdOnClick() {
        let body = {
            id_pessoa: pedidoProtocoloNFSelecionados.id_pessoa,
            cd_pagto: parseInt(checkboxesId),
        };
        setIsLoading(true);
        pedidoProtocoloNFSelecionados.itens.map(async (i) => {
            body.nr_pc = i.NR_PC;
            body.cd_fil = i.CD_FIL;
            body.id_prod = i.ID_PROD;
            body.dt_entrg = i.DT_ENTRG.split(" ")[0];
            await sendForm(body);
        });

        TagManager.dataLayer({
            dataLayer: {
                event: 'event',
                eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
                eventAction: 'clique:botao',
                eventLabel: 'aplicar-alteracoes',
            }
        });

        setIsLoading(false);
        handleDialogModal();
        setTimeout(() => {
            reload();
        }, 400);
    }

    function incrementDate(date, duration) {
        const dateObject = moment(date, "DD/MM/YYYY");
        dateObject.add(parseInt(duration), "day");
        return moment(dateObject).format("DD/MM/YYYY");
    }

    async function loadDescontos() {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");

        try {
            setIsLoading(true);

            //define filtros
            const filters = {
                idFornecedor: pedidoProtocoloNFSelecionados.id_pessoa,
            };
            if (filters.idFornecedor) {
                const r_descontos = await OpcoesRecebimento_controller.getDescontos(token, filters);
                let j_r_descontos = JSON.parse(r_descontos.body);

                if (j_r_descontos.length === 1 && j_r_descontos[0].IN_COND_PADRAO_FORNEC === "S") {
                    j_r_descontos = [];
                }

                if (r_descontos.res.statusCode === 200) {
                    const arrayItens = j_r_descontos.map((e) => {
                        return {
                            ...e,
                            id: parseInt(e.CD_PAGTO),
                            title: `Pagamento em ${incrementDate(
                                pedidoProtocoloNFSelecionados.dt_entrg,
                                e.NR_PRAZO1
                            )}`,
                            description: `${e.NR_PRAZO1} dias após a entrega, desconto de ${e.VP_DESC_ANTEC_PAGTO}%`,
                        };
                    });
                    setItensModal(arrayItens);
                    setIsLoading(false);
                } else {
                    if (
                        j_r_descontos.status === false &&
                        j_r_descontos.message &&
                        j_r_descontos.message.includes("Token inválido!")
                    ) {
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    } else if (
                        j_r_descontos.status === false &&
                        j_r_descontos.message &&
                        (j_r_descontos.message.includes("Campos necessários") ||
                            j_r_descontos.message.includes("Permissão"))
                    ) {
                        throw new Error(j_r_descontos.message);
                    } else {
                        throw new Error("O ocorreu um erro no sistema!");
                    }
                }

                //auditoria
                const str = `Efetuada requisição para recuperação de dados de descontos! 
                Response:( Method: ${r_descontos.res.request.method}, 
                StatusCode: ${r_descontos.res.statusCode}, 
                Body: (limited 100chars)${r_descontos.body.substr(0, 100)} )`;
                Log.info(token, str);
            }
        } catch (error) {
            setIsLoading(false);
            //auditoria
            const str = `Erro na recuperação de dados de descontos! 
                Error:( Message: ${error.message}, Stack: ${error.stack} )`;
            Log.error(token, str);
        }
    }

    async function sendForm(body) {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");

        try {
            const r_antecipacao = await OpcoesRecebimento_controller.put(token, body);
            const j_r_antecipacao = JSON.parse(r_antecipacao.body);

            if (r_antecipacao.res.statusCode === 200) {
                setIsLoading(false);
            } else {
                if (
                    j_r_antecipacao.status === false &&
                    j_r_antecipacao.message &&
                    j_r_antecipacao.message.includes("Token inválido!")
                ) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else if (
                    j_r_antecipacao.status === false &&
                    j_r_antecipacao.message &&
                    (j_r_antecipacao.message.includes("Campos necessários") ||
                        j_r_antecipacao.message.includes("Permissão"))
                ) {
                    throw new Error(j_r_antecipacao.message);
                } else {
                    throw new Error("O ocorreu um erro no sistema!");
                }
            }

            //auditoria
            const str = `Efetuada requisição para recuperação de dados de antecipacao! 
            Response:( Method: ${r_antecipacao.res.request.method}, 
            StatusCode: ${r_antecipacao.res.statusCode}, 
            Body: (limited 100chars)${r_antecipacao.body.substr(0, 100)} )`;
            Log.info(token, str);
        } catch (error) {
            //auditoria
            const str = `Erro na recuperação de dados de antecipacao! 
            Error:( Message: ${error.message}, Stack: ${error.stack} )`;
            Log.error(token, str);
        }
    }

    const SecondaryDescription = (element) => {
        return (
            <React.Fragment>
                {element.description}
                {element.IN_COND_PADRAO_FORNEC === "S" && (
                    <Typography
                        component="p"
                        variant="subtitle2"
                        color="textPrimary"
                        style={{ color: "#159B78" }}
                    >
                        {"Prazo padrão"}
                    </Typography>
                )}
            </React.Fragment>
        );
    };

    return (
        <>
            {itensModal.length !== 0 &&
                <ModalRadioButton
                    checkedId={checkboxesId}
                    isModalOpen={isModalOpen}
                    headerModal={headerModal}
                    btComponent={{ label: "APLICAR ALTERAÇÕES" }}
                    buttonType={"radio"}
                    itensModal={itensModal}
                    setIdOnChange={setIdOnChange}
                    getIdOnClick={verifyUpdate}
                    handleDialogModal={handleDialogModal}
                    SecondaryDescription={SecondaryDescription}
                    isLoading={isLoading}
                />
            }

        </>
    );
}
